import React, { useEffect, useState } from 'react';
import { Wifi, WifiOff, RefreshCcw } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { cn } from '@/lib/utils';

export function NetworkStatus() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [showStatus, setShowStatus] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      setShowStatus(true);
      setTimeout(() => setShowStatus(false), 5000);
    };
    const handleOffline = () => {
      setIsOnline(false);
      setShowStatus(true);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return (
    <AnimatePresence>
      {(showStatus || !isOnline) && (
        <motion.div
          initial={{ y: -100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -100, opacity: 0 }}
          className={cn(
            "fixed top-4 left-1/2 -translate-x-1/2 z-[100] px-6 py-2.5 rounded-full border shadow-2xl backdrop-blur-2xl flex items-center gap-3",
            isOnline 
              ? "bg-emerald-500/10 border-emerald-500/20 text-emerald-400" 
              : "bg-rose-500/10 border-rose-500/20 text-rose-400"
          )}
        >
          {isOnline ? (
            <>
              <Wifi className="h-4 w-4" />
              <span className="text-[10px] font-semibold uppercase tracking-widest">Back Online — Zenith Synced</span>
            </>
          ) : (
            <>
              <WifiOff className="h-4 w-4 animate-pulse" />
              <div className="flex flex-col leading-none">
                <span className="text-[10px] font-semibold uppercase tracking-widest">Offline Mode Active</span>
                <span className="text-[8px] font-medium opacity-60 uppercase tracking-wider mt-0.5">Drafts will sync on reconnect</span>
              </div>
              <button 
                onClick={() => window.location.reload()}
                className="ml-2 p-1 hover:bg-muted/50 rounded-lg transition-colors"
              >
                <RefreshCcw className="h-3 w-3" />
              </button>
            </>
          )}
        </motion.div>
      )}
    </AnimatePresence>
  );
}
